import React from 'react'
import {connect} from 'react-redux'
import ModalForm from "./ModalForm";
import {getOrder} from "../order/OrderReducers";
import {formValueSelector} from 'redux-form'
import {getCurrent} from "../steps/StepsReducers";
import {select, finish} from "../steps/StepsActions";
import {STEP_CREATE_ORDER} from "../steps/StepsContants";
import {receive} from '../result/ResultActions';
import './Modal.css';
import html from 'react-escape-html'
import {FormUtils} from "../utils/FormUtils";
import {OrdersHttpService} from '../http/OrdersHttpService';
import {PaypalHelper} from '../helpers/PaypalHelper';
import {ApplePayHelper} from '../helpers/ApplePayHelper';
import {EdccHelper} from "../helpers/EdccHelper";

const ModalContainer = ({order, state, select, finish, receive, config}) => {

  const previous = () => {
    select(STEP_CREATE_ORDER);
  };

  const onWidgetResult = (error, result) => {
    if (result && result.code === 0) {
      console.log('Widget dismiss event');
      return;
    }

    console.log('Error/Result:', error, result);

    if (result && result.executeRequired) return;

    OrdersHttpService.getOrder(state.order.order.orderId || state.form.modal.values.orderId)
      .then(response => {
        receive(error, result, response);
        finish();
      });
  };

  const getConfigUrl = () => {
    let scriptTag = `<script src="${state.config.environment.widgetUrl}"></script>`;
    return html`${scriptTag}`;
  };

  const getOptionalParameters = () => {
    const selector = formValueSelector('modal');
    const optionalParameters = selector(
      state, 'language', 'colorTheme', 'deviceIdent', 'paypalRecurringBillingAgreement', 'redirectUser', 'mobileView'
    );

    optionalParameters.paymentDetails = FormUtils.getValuesByUsage(selector(state, 'paymentDetailsUsage'), selector(state, 'paymentDetails'));

    if (selector(state, 'products')) {
      optionalParameters.products = selector(state, 'products').replace(/ /g,'').split(',');
    }

    if (selector(state, 'optionalFields')) {
      let creditCard = null;

      if (selector(state, 'useCreditCard')) {
        creditCard = {
          cardHolder: selector(state, 'creditCard.cardHolder'),
          cvcNeeded: selector(state, 'creditCard.cvcNeeded'),
          cofContractSelected: selector(state, 'creditCard.cofContractSelected'),
          cofContract: {
            type: selector(state, 'creditCard.cofContract.type'),
            recurringExpiry: selector(state, 'creditCard.cofContract.recurringExpiry'),
            recurringFrequency: selector(state, 'creditCard.cofContract.recurringFrequency')
          },
          forceChallenge: selector(state, 'creditCard.forceChallenge')
        };
        let confContractType = selector(state, 'creditCard.cofContract.type');
        if(confContractType === null || confContractType === '') {
          creditCard = { ...creditCard, cofContract: null};
        }
      }

      const calcTypes = selector(state, 'ratepayInstallment.calculationTypes');
      const paymentTypes = selector(state, 'ratepayInstallment.paymentTypes');

      optionalParameters.optionalFields = {
        creditCard: creditCard,
        sepa: {
          bic: selector(state, 'sepa.bic'),
          bankName: selector(state, 'sepa.bankName'),
          directDebitType: selector(state, 'sepa.directDebitType'),
        },
        ratepayDirectDebit: {
          bic: selector(state, 'ratepayDirectDebit.bic'),
        },
        ratepayInstallment: {
          bic: selector(state, 'ratepayInstallment.bic'),
          calculationTypes: calcTypes ? calcTypes.replace(/ /g,'').split(',') : null,
          paymentTypes: paymentTypes ? paymentTypes.replace(/ /g,'').split(',') : null
        },
        ideal: {
          bankName: selector(state, 'ideal.bankName'),
        }
      }
    } else {
      optionalParameters.optionalFields = null;
    }

    if (selector(state, 'paypalCallbacks')) {
      optionalParameters.paypal = PaypalHelper.getCallbacksParams()
    }

    if (selector(state, 'applepay')) {
      optionalParameters.applepay = ApplePayHelper.getOptionalParameters(selector(state, 'applepay'));
    }

    if (selector(state, 'edccCallbacks')) {
      optionalParameters.edcc = EdccHelper.getCallbacksParams();
    }

    return optionalParameters;
  };

  const getOptionalParametersTemplate = () => {
    let params = `var optionalParameters = ${JSON.stringify(getOptionalParameters(), null, 2)};
`;

    if (formValueSelector('modal')(state, 'paypalCallbacks')) {
      params += PaypalHelper.getCallbacksTemplate();
    }

    if (formValueSelector('modal')(state, 'applepay.applepayCallbacks')) {
      params += ApplePayHelper.getCallbacksTemplate();
    }

    if (formValueSelector('modal')(state, 'edccCallbacks')) {
      params += EdccHelper.getCallbacksTemplate();
    }

    return html`${params}`;
  };

  const getResultCallback = () => {
    const callbackCode = `${PaypalHelper.getResultCallbacksTemplate()}${ApplePayHelper.getResultCallbacksTemplate()}${EdccHelper.getResultCallbacksTemplate()}`;
    return html`${callbackCode}`;
  }

  const getInitiWidget = () => {
    const selector = formValueSelector('modal');
    const values = selector(state, 'merchantId', 'orderId');
    let params = `
PayEngineWidget.initAsModal(
  '${values.merchantId}',
  '${values.orderId}',
  optionalParameters,
  resultCallback
);
    `;
    return html`${params}`;
  }

  let onSubmit = values => {
    window.PayEngineWidget.initAsModal(
      values.merchantId,
      values.orderId,
      getOptionalParameters(),
      onWidgetResult
    );
  }

  return (
    <div className="row">
      <div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <ModalForm order={order} onSubmit={values => onSubmit(values)} onPrevious={previous}/>
        </div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <h3>Configuration</h3>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getConfigUrl()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getResultCallback()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getOptionalParametersTemplate()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getInitiWidget()}></div>
        </pre>
          </blockquote>
        </div>
      </div>
    </div>
  );
}

ModalContainer.propTypes = {};

const mapStateToProps = (state) => ({
  order: getOrder(state),
  state: state,
  currentStep: getCurrent(state),
  config: state.app.config
});

export default connect(
  mapStateToProps,
  {select, finish, receive}
)(ModalContainer);



// WEBPACK FOOTER //
// ./src/modal/ModalContainer.js